import * as React from 'react';

import { connect } from 'react-redux';
import * as actions from 'actions';

import { Elements } from 'react-stripe-elements';
import { InjectedStripePaymentForm } from '../PaymentForms/StripePaymentForm';
import { StyledMediaQ } from '../../StyledMediaQ';

//Styles
import { constants } from '../../../constants';

// const isTaxExempt = false; // IF THEY HAVE NO GST NUMBER THEN THEY ARE TAX EXEMPT get from provider data 

// const percentTax = (isTaxExempt) ? 0 : 15; // hard coded tax for the moment - THIS WILL BE ON THE USER DATA EVENTUALLY 

const getCostToClient = (props, state) => {
    const credits = (props.userData.credits) ? props.userData.credits : 0;
    const remainingCost = ((props.booking.service.price) + (props.booking.service.price * state.percentTax / 100)) - credits;
    console.log('REMAINING COST THAT IS SENT TO STRIPE', remainingCost);
    
    return remainingCost > 0 ? remainingCost : 0;
}

class PaymentStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            percentTax: (props.provider.isTaxExempt) ? 0 : null // set 15 as default unless specified
        }
    }

    handleSetPercentTax = (percentTax) => {
        console.log('TAX HAS CHANGED', percentTax);
        if (!this.props.provider.isTaxExempt) {
            this.setState({
                percentTax,
            });
        }
    }

    render() {
        const { handleClose, resetErrors, stepperControls, errors, handleConfirmBooking } = this.props;
        const { reverseStepper, advanceStepper } = stepperControls;
        const { paymentFormContainerStyle, paymentSummaryContainerStyle, paymentStepContainerStyle } = styles;
        const credits = (this.props.userData) ? this.props.userData.credits : null;

        return (
            <div label="Payment">
            
                <StyledMediaQ
                    defaultStyles={`
                        flex-direction: row;
                        display: flex;
                        justify-content: space-between;
                    `}
                    break1_maxWidth={constants.layout.breakpoint.break1}
                    styles_break1={'flex-direction: column;'}
                >
                    <div style={ paymentSummaryContainerStyle }>
                        <strong>Purchase Summary</strong>
                        <hr/>
                        <p>
                            <strong>Service Provider:</strong> 
                            <br />{this.props.booking.provider.name}
                        </p>
                        <p>
                            <strong>Consult Date: </strong>
                            <br />{this.props.booking.date}
                        </p>
                        <p>
                            <strong>Consult Time:</strong> 
                            <br />{this.props.booking.time}
                        </p>
                        
                        {   this.state.percentTax &&
                            <div>
                                <span>
                                    <strong >{(credits) ? 'Original ': ''}Price:</strong> 
                                </span>
                                {/* { credits &&
                                    <strong>Cost:</strong> 
                                } */}
                                <div style={{ textAlign: 'right', marginTop: -20 }}>
                                    <br />${this.props.booking.service.price / 100}
                                    <br />+tax ({this.state.percentTax}%) ${(this.props.booking.service.price / 100 * this.state.percentTax / 100).toFixed(2)}
                                    <div style={{ borderBottom: '1px solid black', width: '100%' }}></div>
                                    <strong>$ {((this.props.booking.service.price / 100) + (this.props.booking.service.price / 100 * this.state.percentTax / 100)).toFixed(2)}</strong>
                                    <br />
                                </div>
                                <br />
                                { credits &&
                                    <div>
                                        <strong>Credits:</strong> 
                                        <div style={{ textAlign: 'right', marginTop: -20 }}>
                                            <br />$ {(this.props.userData) ? `${(credits) ? parseFloat(credits/100).toFixed(2) : '0'}` : ''}
                                            <br />- $ {(this.props.booking.service.price/100 + (this.props.booking.service.price / 100 * this.state.percentTax / 100)).toFixed(2)}
                                            <div style={{ borderBottom: '1px solid black', width: '100%' }}></div>
                                            {((credits - this.props.booking.service.price) < 0 ? '-' : '')} ${(this.props.userData) ? `${(credits) ? (((credits - (this.props.booking.service.price + (this.props.booking.service.price * this.state.percentTax / 100))) / 100) * (credits - this.props.booking.service.price < 0 ? -1 : 1)).toFixed(2)  : '0'}` : ''}
                                        </div>
                                        <div style={{ marginTop: 20 }}>
                                            <strong>Price after credits:</strong> 
                                            <div style={{ textAlign: 'right' }}>
                                                $ {(getCostToClient(this.props, this.state) / 100).toFixed(2)}
                                            </div>
                                        </div>
                                    </div> 
                                }
                            </div>
                        }
                    </div>
                    <div style={ paymentFormContainerStyle }>
                        <Elements>
                            <InjectedStripePaymentForm
                                reverseStepper={reverseStepper}
                                errors={errors}
                                handleClose={handleClose}
                                cost={getCostToClient(this.props, this.state)}
                                formValues={ this.props.formValues }
                                handleConfirmBooking={this.props.handleConfirmBooking}
                                onSetPercentTax={this.handleSetPercentTax}
                            />
                        </Elements>
                    </div>
                </StyledMediaQ> 
            </div>
        );
    }
    // this.props.getCreditAmount(this.props.userId);
    // console.log('BOOKING DATA @ Pmnt', bookingData);
}

const mapStateToProps = ({ auth, form, payment, client, booking }) => {
    console.log(form, '@payment');
    console.log('BOOKING DETAILS @ MSTP',booking);
    return {
        userId: auth.authData.id,
        formValues: form.formValues,
        // credit: payment.credit,
        userData: client.clientData,
        booking: { 
            date: booking.details.date,
            time: booking.details.time,
            provider: booking.provider,
            service: booking.service
        }
    };
};

const styles = {
    paymentStepContainerStyle: { 
        flexDirection: 'row', 
        display: 'flex', 
        justifyContent: 'space-between' 
    },
    paymentFormContainerStyle: {
        flex: 1,
    },
    paymentSummaryContainerStyle: {
        maxWidth: 440,
        backgroundColor: '#DDDDDD',
        padding: 20,
        marginRight: 50,
        marginBottom: 50,
        fontSize: constants.text.baseFontStyles.fontSize,
    }
}

export default connect(mapStateToProps, actions)(PaymentStep);


// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/PaymentStep.jsx